module.exports = __webpack_public_path__ + "static/media/trevor1.5414471d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trevor1.jpg
// module id = 99
// module chunks = 0